import React, { useState, useEffect } from "react";
import "./attachment-settings.scss";
import { Form, ButtonItem, GroupItem, SimpleItem } from "devextreme-react/form";
import axios from "axios";
import { Snackbar } from "../../components";
import config from "../../config/config";

const snackbarType = {
	success: "success",
	error: "error",
};

export default function AttachmentSettings() {
	const [paths, setPaths] = useState({});

	const [snackbarOptions, setSnackbarOptions] = useState({
		visible: false,
		type: "",
	});

	const apiUrl = config.Urls.BaseUrl;

	const snackbarMessage = () => {
		let message = "";

		if (snackbarOptions.type === snackbarType.success) {
			message = "Settings were successfully updated.";
		} else if (snackbarOptions.type === snackbarType.error) {
			message = "Failed to update settings. Please try again.";
		}

		return message;
	};

	const getInitialData = async () => {
		try {
			const { data } = await axios.get(`${apiUrl}/endpoints`);
			const keys = Object.keys(data.result);
			const obj = {};
			keys.forEach((key) => (obj[key] = data.result[key].storageUrl));

			setPaths(obj);
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		getInitialData();
	}, []);

	function onFormChange(event) {
		let propName = event.dataField;
		setPaths({
			...paths,
			[propName]: event.value,
		});
	}

	async function onFormSubmit(event) {
		event.preventDefault();

		try {
			await axios.put(`${apiUrl}/endpoints`, paths);
			setSnackbarOptions({
				visible: true,
				type: "success",
			});
		} catch (error) {
			console.error(error);
			setSnackbarOptions({
				visible: true,
				type: "error",
			});
		}
	}

	function onCloseSnackbar() {
		setSnackbarOptions({
			visible: false,
			type: "",
		});
	}

	const submitButtonOptions = {
		text: "Save",
		useSubmitBehavior: true,
		stylingMode: "outlined",
		width: "100px",
	};

	return (
		<React.Fragment>
			<h2 className={"content-block"}>Attachment File Path Settings</h2>

			<div className={"content-block dx-card responsive-paddings"}>
				<form onSubmit={onFormSubmit}>
					<Form
						id={"form"}
						formData={paths}
						colCountByScreen={colCountByScreen}
						onFieldDataChanged={onFormChange}
					>
						<GroupItem colCountByScreen={colCountByScreen}>
							<SimpleItem dataField="isilon" />
							<SimpleItem dataField="kDrive" />
							<SimpleItem dataField="restrictedKDrive" />
						</GroupItem>
						<ButtonItem buttonOptions={submitButtonOptions} />
					</Form>
				</form>
			</div>

			<Snackbar
				message={snackbarMessage()}
				onHiding={onCloseSnackbar}
				of={".content"}
				options={snackbarOptions}
			/>
		</React.Fragment>
	);
}

const colCountByScreen = {
	xs: 1,
	sm: 1,
	md: 2,
	lg: 2,
};
